/*******************************************************************************
GET RANKINGS UPDATES
Returns a set of rankings with player outlooks.
*******************************************************************************/

import showErrorNotificationBar from '../../universal/error-handling/show-error-notification-bar';
import removeButtonProcessingState from '../../universal/button-state/remove-button-processing-state';
import setMinGridWidth from '../../universal/css-grid/set-min-grid-width';

export default async function getUpdates(e) {
    const $showMoreButton = $(e.currentTarget);

    // Options on Show More button
    const sport = String($showMoreButton.data('sport') || '').toLowerCase();
    const pos = String($showMoreButton.data('pos') || '').toLowerCase();
    const type = String($showMoreButton.data('type') || '').toLowerCase();
    const league = String($showMoreButton.data('league') || '').toUpperCase();

    const lastRank = $showMoreButton.data('last-rank') || '';

    // Add the options that were set on the button
    const settings = {};
    if (type) { settings.type = type; }
    if (pos) { settings.pos = pos; }
    if (lastRank) { settings.lastRank = lastRank; }
    if (league) { settings.league = league; }

    const sportDirectories = {
        'cbb': 'cbasketball',
        'cfb': 'cfootball',
        'mlb': 'baseball',
        'nba': 'basketball',
        'nfl': 'football',
        'nhl': 'hockey',
        'pga': 'golf',
        'cri': 'cricket',        
    };
    const sportDirectory = sportDirectories[sport.toLowerCase()] || sport;

    try {
        const response = await $.ajax({
            type   : 'GET',
            url    : `/${sportDirectory}/ajax/get-more-rankings.php`,
            data   : settings,
            timeout: 8000,
        });

        const { rankingsHTML, newLastRank, noMoreRankings, success } = response;

        // Check for errors with the data
        if (response.error || !success) { throw new Error(response.error); }

        $showMoreButton.data('last-rank', newLastRank);
        $showMoreButton.before(rankingsHTML);
        if (noMoreRankings) {
            $showMoreButton.after('<p class="light">There are no more news rankings to display.</p>');
            $showMoreButton.remove();
        }

        // Figure out the minimum tab width so we can add the correct CSS Grid styles for the stat boxes
        setMinGridWidth({
            containers: '.stat-boxes',
            items     : '.stat-box',
            padding   : '16',
        });


    }
    catch (error) {
        showErrorNotificationBar(error.message || 'We were unable to retrieve rankings for you. Please try again.', 3000);
    }

    // Reset the button to its original state
    removeButtonProcessingState($showMoreButton);

}
